<template>
    <div class="new-cars-in-stock__container">
        <h2 class="h2 h2--m-b">New {{ manufacturer }} {{ carsOrVans }} in stock</h2>
        <div class="swiper new-cars-in-stock__swiper" ref="carousel">
            <div class="swiper-wrapper new-cars-in-stock__swiper-wrapper">
                <new-cars-in-stock-card class="swiper-slide" v-for="(vehicle, index) in newVehiclesInStock" :key="'stock-card-' + index" :vehicle="vehicle">
                </new-cars-in-stock-card>
            </div>
        </div>
        <div class="btn-container btn-container--space-between" v-if="numVehicles > 3">
            <div class="new-cars-in-stock__swiper-btn new-cars-in-stock__swiper-prev" ref="swiper-prev"></div>
            <a class="btn btn--primary" :href="link">View all stock</a>
            <div class="new-cars-in-stock__swiper-btn new-cars-in-stock__swiper-next" ref="swiper-next"></div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import Swiper, {Navigation} from 'swiper';
import NewCarsInStockCard from './NewCarsInStockCard.vue';
import GetManufacturerFromBrand from '../../../used-vue/api/GetManufacturerFromBrand';

export default {
    components: {
        NewCarsInStockCard,
    },
    data() {
        return {
            swiperInstance: null
        };
    },
    computed: {
        ...mapState('NewVehicleData', ['vehicle', 'newVehiclesInStock']),
        manufacturer() {
            return GetManufacturerFromBrand(this.vehicle.brand);
        },
        numVehicles() {
            return this.newVehiclesInStock.length;
        },
        carsOrVans() {
            if (this.vehicle.type == 'car') {
                return 'cars';
            }

            return 'vans';
        },
        link() {
            return '/' + this.vehicle.brand + '/new-cars-in-stock/results';
        }
    },
    mounted() {
        this.$nextTick(function() {
            this.swiperInstance = new Swiper(this.$refs['carousel'], {
                modules: [Navigation],
                grabCursor: true,
                slidesPerView: 1,
                slidesPerGroup: 1,
                spaceBetween: 15,
                loop: false,
                navigation: {
                    prevEl: this.$refs['swiper-prev'],
                    nextEl: this.$refs['swiper-next'],
                },
                breakpoints: {
                    768: {
                        slidesPerView: 2,
                        slidesPerGroup: 2,
                    },
                    992: {
                        slidesPerView: 3,
                        slidesPerGroup: 3,
                    },
                },
                on: {
                    slideChange: () => {
                        if (this.swiperInstance.isBeginning) {
                            this.$refs['swiper-prev'].classList.add('new-details__swiper-btn--disabled');
                            this.$refs['swiper-next'].classList.remove('new-details__swiper-btn--disabled');
                            return;
                        }

                        if (this.swiperInstance.isEnd) {
                            this.$refs['swiper-prev'].classList.remove('new-details__swiper-btn--disabled');
                            this.$refs['swiper-next'].classList.add('new-details__swiper-btn--disabled');
                            return;
                        }

                        this.$refs['swiper-prev'].classList.remove('new-details__swiper-btn--disabled');
                        this.$refs['swiper-next'].classList.remove('new-details__swiper-btn--disabled');
                    },
                }
            });
            // on the first slide
            if (this.swiperInstance.isBeginning) {
                this.$refs['swiper-prev'].classList.add('new-details__swiper-btn--disabled');
                this.$refs['swiper-next'].classList.remove('new-details__swiper-btn--disabled');
                return;
            } else if (this.swiperInstance.isEnd) {
                this.$refs['swiper-prev'].classList.remove('new-details__swiper-btn--disabled');
                this.$refs['swiper-next'].classList.add('new-details__swiper-btn--disabled');
                return;
            }
            console.log('setup swiper on ', this.$refs['carousel'])
        });
    }
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// resources/assets/js/new-vue/components/details/NewCarsInStock.vue